//Holdout for PDM feature flag: holdout-q4-2025
// fuction to check holdout group ann add class ab-enabled
const checkHoldout = _ => {
  const holdoutGroup = window._growthbook?.getFeatureValue('holdout-q4-2025', 'OFF');
  if(holdoutGroup != 'holdout-q4-2025'){
    document.documentElement.classList.add("ab-enabled")
    window.ab_enabled = true
  }
}
// HOLDOUTGROUP: holdout-q4-2025
// PDM Feature Flag: mobile-carousel-test_v2

const readMobileCarousel = () => {
    const holdoutGroup = window._growthbook?.getFeatureValue('holdout-q4-2025', 'OFF');

    if (holdoutGroup === 'holdout-q4-2025') {
        return;
    }

    const isMobileCarouselEnabled = true; // Variant Winner

    if (isMobileCarouselEnabled) {
        const carouselContainer = document.querySelector('.pain-categories-container.container-test');

        if (carouselContainer) {
            carouselContainer.classList.remove('container-test');
        }
    }
};

// PDM Feature Flag: sticky-atc
const readStickyMobile = () => {
    const holdoutGroup = window._growthbook?.getFeatureValue('holdout-q4-2025', 'OFF');

    if (holdoutGroup === 'holdout-q4-2025') {
        return;
    }

    const isStickyMobileEnabled = true; // Variant Winner

    if (isStickyMobileEnabled) {
        const stickyForm = document.querySelector('.product-sticky-form.product-sticky-form-mobile.hidden-lap-and-up.sticky-form-mobile');

        if (stickyForm) {
            stickyForm.classList.remove('sticky-form-mobile');
        }
    }
};

// PDM Feature Flag: info-cards-feat
const readInfoCardsFeat = () => {
    const holdoutGroup = window._growthbook?.getFeatureValue('holdout-q4-2025', 'OFF');

    const isInfoCardsEnabled = window._growthbook?.getFeatureValue('info-cards-feat', false);

    if (holdoutGroup === 'holdout-q4-2025') {
        return;
    }

    if (isInfoCardsEnabled) {
        const productHighlightSections = document.querySelectorAll('[class*="product-highlight-section-"]');
        productHighlightSections.forEach(section => {
            section.classList.remove('test-section');
        });

        const aiProductHighlights = document.querySelectorAll('[class*="ai-product-highlight-"]');
        aiProductHighlights.forEach(highlight => {
            highlight.classList.add('test-original-section');
        });
    }
};

(() => {
    window.growthbook_queue = window.growthbook_queue || [];
    window.growthbook_queue.push((gb) => {
        // Function that uses feature flags to make changes to the page
        const applyFeatureFlags = () => {
            // Llamadas a feature flags activos se agregan aquí
            readMobileCarousel();
            readStickyMobile();
            readInfoCardsFeat();
        };
        checkHoldout()
        // Call your function initially plus whenever new data is received
        applyFeatureFlags();
        document.addEventListener("growthbookdata", _ => {
            checkHoldout()
            applyFeatureFlags()
        });
    });
})();